import { render, staticRenderFns } from "./allLogistics.vue?vue&type=template&id=619e8e7e&scoped=true"
import script from "./allLogistics.vue?vue&type=script&lang=js"
export * from "./allLogistics.vue?vue&type=script&lang=js"
import style0 from "./allLogistics.vue?vue&type=style&index=0&id=619e8e7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619e8e7e",
  null
  
)

export default component.exports